var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "aside",
    {
      staticClass: "i-aside",
      class: {
        "screen-ready": _vm.isScreenReady,
      },
    },
    [
      _c("i-nav", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !(_vm.isVrMode || _vm.isFullscreen),
            expression: "!(isVrMode || isFullscreen)",
          },
        ],
        staticClass: "i-nav-parent",
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isVrMode || _vm.isFullscreen,
              expression: "isVrMode || isFullscreen",
            },
          ],
          staticClass: "aside-icon-close",
          attrs: { role: "button" },
          on: {
            click: function ($event) {
              return _vm.handleExitFullscreen()
            },
          },
        },
        [
          _c("svg-icon", {
            staticClass: "icon-close",
            attrs: { name: "close" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }